// Ported verbatim from the mobile app (PrecisionReactNative src/common/assets/images/equipment/eqRowerSVG.tsx); generated — regenerate rather than edit.
import * as React from "react";

type Props = {
  fill: string;
  width?: number;
  height?: number;
};

function EqRowerSVG(props: Props) {
  const {fill, width = 24, height = 24} = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none">
      <g clip-path="url(#clip0_513_61439)">
        <path
          d="M12.75 8.25H6"
          stroke="#1F2224"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M19.5 12C21.5711 12 23.25 10.3211 23.25 8.25C23.25 6.17893 21.5711 4.5 19.5 4.5C17.4289 4.5 15.75 6.17893 15.75 8.25C15.75 10.3211 17.4289 12 19.5 12Z"
          stroke="#1F2224"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M0.75 14.9984H17.25L18.513 11.8672"
          stroke="#1F2224"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M3.75 15L1.5 19.5"
          stroke="#1F2224"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M17.25 15L19.5 19.5"
          stroke="#1F2224"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
      </g>
    </svg>
  );
}

export default EqRowerSVG;
